import { adjustContentVisibility, SectionParagraph, SectionTitle as Title } from '@/components/shared/Content';
import { font, themedColor } from '@lemonade-hq/cdk';
import { Pill } from '@lemonade-hq/nuis';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis-atomic';
import type { HTMLAttributes } from 'react';
import React from 'react';
import styled from 'styled-components';
import { Section } from './StyledElements';

export type CoverageSectionVariant = 'modern' | 'default';

export const CoverageItemTitleText = styled.h3<{ $variant?: CoverageSectionVariant }>`
  text-align: center;
  text-wrap: ${({ $variant }) => ($variant === 'modern' ? 'nowrap' : 'balance')};
  ${font('main', {
    fontSize: '2.0rem',
    lineHeight: '2.4rem',
    fontWeight: 'bold',
  })}

  ${MEDIA_QUERIES.tablet`
    ${font('main', {
      fontSize: '2.2rem',
      lineHeight: '3rem',
      fontWeight: 'bold',
    })}
  `}
  ${MEDIA_QUERIES.desktop`
    ${font('main', {
      fontSize: '2.6rem',
      lineHeight: '3.4rem',
      fontWeight: 'bold',
    })}
  `}
`;

export const StyledTitle = styled(Title)`
  white-space: pre-line;
  ${MEDIA_QUERIES.tabletAndDesktop`
      white-space: normal;
    `}
`;

export const Subtitle = SectionParagraph;

export const CoverageItemDescriptionText = styled.p`
  color: #797979;
  text-align: center;
  text-wrap: balance !important;
  ${font('main', {
    fontSize: '1.4rem',
    lineHeight: '1.9rem',
  })}

  ${MEDIA_QUERIES.tabletAndDesktop`
    ${font('main', {
      fontSize: '1.6rem',
      lineHeight: '2.1rem',
    })}
  `}
`;

type ThemedColor = Parameters<typeof themedColor>[0];

export const StyledPill = styled(Pill)<{ backgroundColor?: ThemedColor }>`
  color: ${themedColor('white')};
  background-color: ${({ backgroundColor = 'primary' }): ReturnType<typeof themedColor> =>
    themedColor(backgroundColor)};
  position: absolute;
  top: 0;
  right: 50%;
  transform: translateX(calc(50% + 60px));
`;

export const StyledSection = styled(Section)`
  ${adjustContentVisibility};
`;

export interface CarCoverage {
  ppm: Coverage[];
  fixed: Coverage[];
}

export interface Coverage {
  id?: string;
  title: string | string[];
  description: string | string[];
  alt: string;
  background: string | StaticImageData;
  backgroundDesktop?: string;
  altColorBackground?: string;
  altColorBackgroundDesktop?: string;
  preElement?: React.ReactElement;
  pill?: {
    text: string;
    backgroundColor?: ThemedColor;
  };
}

export interface CoverageSectionProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle: string;
  coverages: Coverage[];
  itemWidth?: number | [number, number] | [number, number, number];
  itemMargin?: number | [number, number] | [number, number, number];
  containerWidth?: number | [number, number] | [number, number, number];
  darkBackground?: boolean;
  variant?: CoverageSectionVariant;
}
